// extracted by mini-css-extract-plugin
export default {"container":"styles_container__whsY2","text":"styles_text__kq4uK","leftColumn":"styles_leftColumn__PjRpR","rightColumn":"styles_rightColumn__3ssRm","link":"styles_link__BhAB5"};